<template>
  <ya-site-resource-list resource="worker" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteSyncMonitor',
  components: { YaSiteResourceList },
}
</script>
